import type { Project } from '@/lib/projects';
import { ProjectIcon } from './ProjectIcon';

type Props = {
  project: Project;
};

export function PhoneMockup({ project }: Props) {
  return (
    <div
      className="relative mx-auto"
      style={{
        width: 240,
        maxWidth: '100%',
        aspectRatio: '1 / 2',
      }}
    >
      <div
        className="relative w-full h-full flex items-center justify-center overflow-hidden"
        style={{
          borderRadius: 36,
          background: '#000',
          border: '1px solid rgba(255,255,255,0.08)',
          padding: 6,
          boxShadow:
            '0 24px 80px rgba(0,0,0,0.55), 0 0 0 1px rgba(255,255,255,0.04) inset',
        }}
      >
        <div
          className="relative w-full h-full overflow-hidden flex items-center justify-center"
          style={{
            borderRadius: 30,
            background: project.gradient,
          }}
        >
          {/* Notch */}
          <div
            className="absolute top-2 left-1/2 -translate-x-1/2 rounded-full"
            style={{
              width: 64,
              height: 18,
              background: '#000',
              zIndex: 3,
            }}
          />
          <div
            className="absolute inset-0 opacity-35"
            style={{
              background:
                'radial-gradient(circle at 50% 10%, rgba(255,255,255,0.35), transparent 55%)',
            }}
          />
          <div
            className="absolute inset-0"
            style={{
              background:
                'linear-gradient(180deg, transparent 60%, rgba(0,0,0,0.4) 100%)',
            }}
          />
          <div className="relative flex flex-col items-center gap-3 text-center px-5">
            <ProjectIcon initials={project.initials} gradient={project.gradient} size={56} />
            <div
              className="font-display italic"
              style={{ fontSize: 22, color: '#fff', lineHeight: 1, letterSpacing: '-0.02em' }}
            >
              {project.name}
            </div>
            <div
              className="font-mono"
              style={{
                fontSize: 9,
                color: 'rgba(255,255,255,0.8)',
                letterSpacing: '0.15em',
                textTransform: 'uppercase',
              }}
            >
              {project.categoryLabel}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
